import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint:number = 768) => {
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < breakpoint);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    const fontResponsive = (mobile: number | string, desktop: number | string): any => {
        return isMobile ? mobile : desktop;
    };

    return { isMobile, fontResponsive };
};

export default useIsMobile;